import React, { Component, Fragment } from "react";
import Helmet from "react-helmet";

import { title, List } from "utils";

import { Header, SubmissionsKanban } from "components";
import { Button, Switch, Icon } from "antd";
import SubmissionsList from "components/SubmissionsList";

class SubmissionListPage extends Component {
  constructor(props) {
    super(props);

    const { type } = this.props;
    let kanban = localStorage.getItem("submissions[kanban]");

    this.state = {
      kanban: kanban === "true",
    };

    this.toggleKanban = this.toggleKanban.bind(this);
  }

  toggleKanban() {
    localStorage.setItem("submissions[kanban]", !this.state.kanban);
    this.setState({ kanban: !this.state.kanban });
  }

  render() {
    const bread = [{ text: "Liste des soumissions" }];

    const Content = (props) => {
      return props.kanban ? <SubmissionsKanban /> : <List type="submissions" />;
    };

    return (
      <Fragment>
        <Helmet>{title("Liste des soumissions")}</Helmet>

        <Header title="Soumissions" bread={bread} />

        <div className="toggler-wrap">
          <Switch
            checked={this.state.kanban}
            onChange={this.toggleKanban}
            checkedChildren={<Icon type="branches" />}
            unCheckedChildren={<Icon type="table" />}
          />
        </div>

        <div className="submission-list-page main-content" style={{ minHeight: "90%" }}>
          <Content kanban={this.state.kanban} />
        </div>
      </Fragment>
    );
  }
}

export default SubmissionListPage;
